"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNotification = exports.Notification = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const Notification_1 = require("@reactionable/core/lib/ui/notification/Notification");
const Toast_1 = tslib_1.__importDefault(require("react-bootstrap/Toast"));
function Notification(_a) {
    var { onClose, variant, title, children } = _a, props = tslib_1.__rest(_a, ["onClose", "variant", "title", "children"]);
    return (jsx_runtime_1.jsxs(Toast_1.default, Object.assign({ autohide: true, onClose: onClose, style: {
            position: "fixed",
            top: "1vw",
            right: "1vw",
            zIndex: 9999,
        }, className: variant ? "border-" + variant : "" }, props, { children: [jsx_runtime_1.jsx(Toast_1.default.Header, Object.assign({ className: variant ? "text-" + variant : "" }, { children: jsx_runtime_1.jsx("strong", Object.assign({ className: "mr-auto" }, { children: title }), void 0) }), void 0),
            jsx_runtime_1.jsx(Toast_1.default.Body, { children: children }, void 0)] }), void 0));
}
exports.Notification = Notification;
const useNotification = (props) => {
    return Notification_1.useNotification(Object.assign(Object.assign({}, props), { Component: Notification }));
};
exports.useNotification = useNotification;
//# sourceMappingURL=Notification.js.map